import * as React from 'react';
import type { QuickLoginValue } from './hooks';

const DEFAULT_QUICK_LOGIN_VALUE: QuickLoginValue = {
  state: {
    toggleValue: false,
    showTooltip: false,
    isQuickLoginFeatureEnabled: false,
    isQuickLoginHookReady: false,
    quickLoginStatus: {
      enabled: false,
      displayName: '',
      accType: undefined,
      hasNeverEnabledQuickLogin: undefined,
    },
  },
  actions: {
    setToggleValue: () => {},
    setShowTooltip: () => {},
    setUserHasSeenTooltip: () => {},
    shouldTriggerQuickLoginActivation: () => Promise.resolve(false),
    setQuickLoginActivationPromptTimestamp: () => {},
    checkQuickLoginStatus: () =>
      Promise.resolve({ isUserWhitelisted: false, isUserEnabled: false }),
    shouldShowQuickLoginToggle: () => Promise.resolve(false),
    loginWithQuickLogin: () =>
      Promise.resolve({
        error: undefined,
        data: undefined,
        error_msg: undefined,
      }),
  },
  apis: {
    enableQuickLogin: () => Promise.resolve({}),
    disableQuickLogin: () => Promise.resolve({}),
    quickLogin: () => Promise.resolve({}),
    checkQuickLoginStatus: () => Promise.resolve({}),
  },
};

export const QuickLoginContext = React.createContext<QuickLoginValue>(
  DEFAULT_QUICK_LOGIN_VALUE
);

export const useQuickLoginContext = () => {
  return React.useContext(QuickLoginContext);
};
